import React, { useCallback } from 'react';
import { CloudIcon } from '@heroicons/react/24/outline';
import AnalysisPageBase from './AnalysisPageBase';
import { ApiProvider } from '../../types';
import { DecodoService } from '../../services/decodoService';
import RoleGuard from '../../components/RoleGuard';

const AnalyzeDecodoPage: React.FC = () => {
  // Create a stable wrapper function that matches the expected signature
  const analyzeWithDecodo = useCallback(async (imageUrl: string) => {
    const decodoService = new DecodoService();
    
    // Since AnalysisPageBase expects imageUrl, we need to create a File from the URL
    // This is a bit of a workaround since DecodoService expects a File
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const file = new File([blob], 'uploaded-image.jpg', { type: blob.type });
      
      return await decodoService.analyzeImage(file);
    } catch (error) {
      console.error('Error converting URL to File:', error);
      throw error;
    }
  }, []);

  return (
    <RoleGuard 
      requireProvider={ApiProvider.DECODO}
      // showUpgradePrompt={true} // Removed as RoleGuard now handles upgrade prompts internally
    >
      <AnalysisPageBase
        apiProvider={ApiProvider.DECODO}
        analyzeFunction={analyzeWithDecodo}
        pageTitle="Decodo SERP Analysis"
        pageDescription="Get comprehensive market insights with Decodo's advanced SERP API technology for shopping, images, and web results."
        icon={CloudIcon}
      />
    </RoleGuard>
  );
};

export default AnalyzeDecodoPage;
